<div class="image-show-wrapper">
  <div class="image-show-text" *ngIf="titleText || bodyText">
    <h4 class="image-show-title" *ngIf="titleText">{{ titleText }}</h4>
    <p class="image-show-body" *ngIf="bodyText">{{ bodyText }}</p>
  </div>

  <div *ngIf="showImage; else imagePlaceholder">
    <img class="image-show-img" [src]="imageSrc" [alt]="altText" />
  </div>

  <ng-template #imagePlaceholder>
    <!-- if an image is missing, show text/html in its place -->
    <div *ngIf="imageText" class="image-show-img-alt" [innerHTML]="imageText"></div>
  </ng-template>

  <!-- render HTML when available underneath -->
  <div *ngIf="htmlContent; else renderJson" class="image-show-html" [innerHTML]="htmlContent"></div>

  <!-- show JSON/text content beneath the image only if no htmlContent -->
  <ng-template #renderJson>
    <div *ngIf="content; else simpleJson" class="image-show-content">
      <div class="row">
        <div class="col-lg-6 left-column">
          <div *ngFor="let section of content.leftSections" class="content-section">
            <h5 *ngIf="section.heading" class="section-heading">{{ section.heading }}</h5>
            <p *ngIf="section.paragraph" class="section-paragraph">{{ section.paragraph }}</p>
            <ul *ngIf="section.items" class="section-list">
              <li *ngFor="let item of section.items">
                <ng-container *ngIf="isComplexItem(item); else plainItem">
                  <strong>{{ item.bold }}</strong> <span *ngIf="item.text">{{ item.text }}</span>
                </ng-container>
                <ng-template #plainItem>
                  {{ item.text || item }}
                </ng-template>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 right-column">
          <div *ngFor="let table of content.tables" class="table-container mb-4">
            <table class="styled-table shadow-sm">
              <thead>
                <tr>
                  <th *ngFor="let header of table.headers">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of table.rows">
                  <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <ng-template #simpleJson>
      <pre class="image-show-json" *ngIf="jsonText">{{ jsonText }}</pre>
    </ng-template>
  </ng-template>
</div>

<ng-template #noImage></ng-template>
